export default {
  title: 'Contatto e sincronizzazione',
  labels: {
    occ_phone_number: 'Numero di telefono del call center',
    company_phone_number: 'Numero di telefono del ristorante',
    has_google_business_sync: 'Sincronizza con Google Business',
    has_foodamigos_sync: 'Sincronizza con i servizi Fooodamigos',
  },
  placeholders: {
    occ_phone_number: 'Seleziona numero di telefono dalla lista',
  },
};
